var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-success-message"},[_c('h2',{staticClass:"align-center"},[_vm._v("You're all set!")]),_c('p',[_vm._v(_vm._s(_vm.cMsgT))]),_c('router-link',{staticClass:"btn large secondary",attrs:{"to":{
            name: 'account-history',
            params: { address: _vm.address },
        }}},[_vm._v(" Access your wallet ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }